import "./UpdateTickeSolved.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";
import {sleep} from "../../helper/helper";

const UpdateTicketSolved = ({ inputs, title }) => {
  const [ticketSolved, setTicketSolved] = useState({});
  const [ticketUpdateSolved, setTicketUpdateSolved] = useState({});
  const [categoryId, setCategoryId] = useState(false);
  const [statusId, setStatusId] = useState(false);
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/solve/${ticketId}`);
  const navigate = useNavigate();

  useEffect(() => {
    setTicketSolved(data);
  }, [data]);



  const handleSelectCategoryID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };

  const handleSelectStatusID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setStatusId(value);
  };


  const handleChange = (e) => {
    setTicketUpdateSolved((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };


  const handleClick = async (e) => {
    e.preventDefault();
    setSending("On Submit")
    try {
      setSending("Mengirim Data")
      const newTicketUpdate = {
        ...ticketUpdateSolved,
        category_id : categoryId[0],
        status_id : statusId[0]
      };

     const res= await newRequest.put(`/solve/${ticketId}`, newTicketUpdate, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
      if (res.status == 200) {
        await sleep(2000)
        setSending("Berhasil Mengirim Data")
        navigate(`/solve/${ticketId}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err);
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <div className="detailItem">
              <span className="itemKey">Ticket ID:</span>
              <span className="itemValue">{ticketId}</span>
            </div>
            <form>

              <div className="formInput">
                <label>Segment Customer </label>
                <input type="" placeholder={ticketSolved.segment_customer} onChange={handleChange}
                          id="segment_customer"/>
                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input type={input.type} placeholder={input.placeholder} onChange={handleChange} id={input.id}/>
                    </div>
                ))}
                <label className="label">Status Id</label>
                <select id="status_id" placeholder="DOWN" onChange={handleSelectStatusID}>
                  <option value="OPEN">Open</option>
                  <option value="PENDING">Pending</option>
                  <option value="SOLVED">Solved</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
                <label className="label">Category</label>
                <select id="category_id" onChange={handleSelectCategoryID}>
                  <option value="DOWN">Down</option>
                  <option value="UP">UP Internet</option>
                  <option value="ONUBAD">ONU Bad</option>
                  <option value="FIBERCUT">Fiber Cut</option>
                  <option value="POWEROFF">Power OFF</option>
                  <option value="INTERMITTEN">INTERMITTEN</option>
                  <option value="LOOPING">LOOPING</option>
                  <option value="BENDING">BENDING</option>

                  <label>Down Time</label>
                  <input type="text" placeholder={ticketSolved.down_time} onChange={handleChange} id="down_time"/>
                </select>

                <div>
                </div>
                <button onClick={handleClick}>Send</button>
              </div>
            </form>
          </div>
        </div>
        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default UpdateTicketSolved;
